var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('app-navigation'),_c('v-main',[(!_vm.isLoading)?_c('router-view',{key:_vm.$route.path}):_vm._e()],1),_c('app-footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }